var _radialGradient, _linearGradient, _radialGradient2, _linearGradient2, _radialGradient3, _linearGradient3, _radialGradient4, _linearGradient4, _radialGradient5, _linearGradient5, _radialGradient6, _linearGradient6, _radialGradient7, _linearGradient7, _radialGradient8, _linearGradient8, _radialGradient9, _radialGradient10, _linearGradient9, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _radialGradient19, _radialGradient20, _radialGradient21, _radialGradient22, _linearGradient10, _radialGradient23, _linearGradient11, _radialGradient24, _linearGradient12, _radialGradient25, _linearGradient13, _radialGradient26, _linearGradient14, _radialGradient27, _radialGradient28, _radialGradient29, _radialGradient30, _radialGradient31, _radialGradient32, _radialGradient33, _radialGradient34, _radialGradient35, _radialGradient36, _radialGradient37, _radialGradient38, _radialGradient39, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _path24, _path25, _circle2, _circle3, _path26, _path27, _circle4, _path28, _path29, _path30, _path31, _circle5, _circle6, _path32, _path33, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__o",
    cx: 305.824,
    cy: 1777.336,
    r: 211.111,
    gradientTransform: "matrix(.931 0 0 .114 -37.782 284.061)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1f4b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5119,
    stopColor: "#e9f9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5188,
    stopColor: "#e9f9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#fff"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#fff485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#ffed26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#ffea00"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__p",
    cx: 380.018,
    cy: 389.743,
    r: 94.568,
    gradientTransform: "matrix(1 0 0 .3 0 272.76)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__a"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff9e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5145,
    stopColor: "#fffacd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#fff6ab"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__q",
    cx: 386.198,
    cy: 284.835,
    r: 110.352,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__b"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9aa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#ff8188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4555"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__r",
    cx: 380.018,
    cy: 177.832,
    r: 94.568,
    gradientTransform: "matrix(1 0 0 .3 0 124.455)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__c"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe3e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#ffc5c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9aa2"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__s",
    cx: 369.709,
    cy: 83.243,
    r: 97.38,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__d"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaf9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#d6f6fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68e7fd"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__t",
    cx: 210.852,
    cy: 175.447,
    r: 107.295,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__e"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68e7fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1693,
    stopColor: "#42e3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#00dcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9716,
    stopColor: "#00c1fc"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__u",
    cx: 209.812,
    cy: 279.071,
    r: 70.449,
    gradientTransform: "matrix(1 0 0 .485 0 143.709)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__f"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3692bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#0681af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#0055a3"
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__v",
    cx: 295.405,
    cy: 249.565,
    r: 190.739,
    gradientTransform: "matrix(0 1 -.235 0 354.144 -45.84)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__g"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6f6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#c0dae9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#bad6e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8abbd5"
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__w",
    cx: 237.71,
    cy: 170.082,
    r: 77.962,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__h"
  })), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__x",
    cx: 230.087,
    cy: 350.224,
    r: 47.456,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__h"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__i"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8abbd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#6cabca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0681af"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__y",
    cx: 149.108,
    cy: 240.741,
    r: 147.406,
    gradientTransform: "matrix(-.709 .706 -1.501 -1.507 616.108 498.268)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__i"
  })), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__z",
    cx: 249.113,
    cy: 269.308,
    r: 98.42,
    gradientTransform: "matrix(-.709 .706 -1.501 -1.507 829.845 499.304)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__i"
  })), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__A",
    cx: 296.59,
    cy: 151.411,
    r: 266.733,
    gradientTransform: "matrix(-.7071 -.7071 .29486 -.29486 461.675 405.832)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__g"
  })), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__B",
    cx: 313.809,
    cy: 170.271,
    r: 258.477,
    gradientTransform: "matrix(-.7071 -.7071 .29486 -.29486 485.509 442.436)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__g"
  })), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__C",
    cx: 165.199,
    cy: 256.753,
    r: 58.653,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__h"
  })), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__D",
    cx: 351.503,
    cy: 153.691,
    r: 262.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8abbd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#6cabca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8934,
    stopColor: "#0681af"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__E",
    cx: 150.725,
    cy: 212.818,
    r: 129.041,
    gradientTransform: "matrix(.5 .866 -2.772 1.6 787.199 -127.055)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__g"
  })), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__F",
    cx: 155.382,
    cy: 252.056,
    r: 122.636,
    gradientTransform: "matrix(.5 .866 -2.772 1.6 925.273 -217.525)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__g"
  })), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__G",
    cx: 387.786,
    cy: 177.832,
    r: 84.662,
    gradientTransform: "matrix(1 0 0 .3 0 124.455)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__c"
  })), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__H",
    cx: 377.666,
    cy: 83.243,
    r: 93.173,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__d"
  })), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__I",
    cx: 215.598,
    cy: 89.894,
    r: 97.237,
    gradientTransform: "matrix(1 0 0 .325 0 60.713)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__a"
  })), _radialGradient22 || (_radialGradient22 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__J",
    cx: 194.548,
    cy: 7.729,
    r: 92.701,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__b"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5119,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6858,
    stopColor: "#fbd113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#f6ab31"
  }))), _radialGradient23 || (_radialGradient23 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__K",
    cx: 340.299,
    cy: 61.941,
    r: 126.033,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__j"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4f19b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#a4ed62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7855,
    stopColor: "#85e026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#72d800"
  }))), _radialGradient24 || (_radialGradient24 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__L",
    cx: 215.598,
    cy: 461.094,
    r: 97.237,
    gradientTransform: "matrix(1 0 0 .325 0 311.417)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__k"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__l"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0f6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5145,
    stopColor: "#ddf7c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5599,
    stopColor: "#daf7c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#c4f19b"
  }))), _radialGradient25 || (_radialGradient25 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__M",
    cx: 194.548,
    cy: 378.929,
    r: 92.701,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__l"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__m"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7be700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5119,
    stopColor: "#72d800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8085,
    stopColor: "#26b847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#00a96a"
  }))), _radialGradient26 || (_radialGradient26 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__N",
    cx: 340.299,
    cy: 433.141,
    r: 126.033,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__m"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "customer-support_svg__n"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#ff4555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9424,
    stopColor: "#eb2a42"
  }))), _radialGradient27 || (_radialGradient27 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__O",
    cx: 506.091,
    cy: 142.679,
    r: 128.976,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__n"
  })), _radialGradient28 || (_radialGradient28 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__P",
    cx: 387.786,
    cy: 389.743,
    r: 84.662,
    gradientTransform: "matrix(1 0 0 .3 0 272.76)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__a"
  })), _radialGradient29 || (_radialGradient29 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__Q",
    cx: 392.703,
    cy: 284.835,
    r: 107.221,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__b"
  })), _radialGradient30 || (_radialGradient30 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__R",
    cx: 506.091,
    cy: 354.59,
    r: 128.976,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__j"
  })), _radialGradient31 || (_radialGradient31 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__S",
    cx: 60.018,
    cy: 389.743,
    r: 94.568,
    gradientTransform: "matrix(1 0 0 .3 0 272.76)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__c"
  })), _radialGradient32 || (_radialGradient32 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__T",
    cx: 34.92,
    cy: 302.129,
    r: 92.701,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__d"
  })), _radialGradient33 || (_radialGradient33 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__U",
    cx: 72.818,
    cy: 184.943,
    r: 94.568,
    gradientTransform: "matrix(1 0 0 .3 0 129.432)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__k"
  })), _radialGradient34 || (_radialGradient34 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__V",
    cx: 47.72,
    cy: 97.329,
    r: 92.701,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__l"
  })), _radialGradient35 || (_radialGradient35 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__W",
    cx: 198.891,
    cy: 149.79,
    r: 128.976,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__m"
  })), _radialGradient36 || (_radialGradient36 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__X",
    cx: 186.091,
    cy: 354.59,
    r: 128.976,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__n"
  })), _radialGradient37 || (_radialGradient37 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__Y",
    cx: 219.169,
    cy: 279.071,
    r: 63.451,
    gradientTransform: "matrix(1 0 0 .485 0 143.709)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__f"
  })), _radialGradient38 || (_radialGradient38 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__Z",
    cx: 219.169,
    cy: 175.447,
    r: 103.345,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#customer-support_svg__e"
  })), _radialGradient39 || (_radialGradient39 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "customer-support_svg__aa",
    cx: 359.358,
    cy: 244.059,
    r: 129.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5038,
    stopColor: "#00c1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9755,
    stopColor: "#0094ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__o)",
    d: "M249.6 512c113.107 0 204.798-11.462 204.798-25.6H44.802c0 14.138 91.691 25.6 204.798 25.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__p)",
    d: "M428.8 371.199l-92.826 12.613C346.29 399.354 363.948 409.6 384 409.6h64c-9.741 0-15.424-23.414-19.2-38.401z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__q)",
    d: "M448 294.4h-64c-31.812 0-57.6 25.788-57.6 57.6 0 11.76 3.524 22.696 9.574 31.812h91.752c-8.555-33.96-1.797-89.412 20.274-89.412z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__r)",
    d: "M428.8 159.287L335.974 171.9c10.316 15.542 27.974 25.788 48.026 25.788h64c-9.741 0-15.424-23.414-19.2-38.401z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__s)",
    d: "M448 82.488h-64c-31.812 0-57.6 25.788-57.6 57.6 0 11.76 3.524 22.696 9.574 31.812h91.752c-8.555-33.959-1.797-89.412 20.274-89.412z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__t)",
    d: "M294.028 179.2h-64c-35.346 0-64 28.654-64 64 0 14.408 4.761 27.704 12.796 38.4h93.499c-10.727-37.355-3.492-102.4 21.705-102.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__u)",
    d: "M268.428 268.799L178.824 281.6c11.676 15.545 30.266 25.6 51.204 25.6h64c-10.149 0-21.279-23.355-25.6-38.401z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__v)",
    d: "M255.628 64h25.6v358.4h-25.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__w)",
    d: "M268.428 166.4L255.628 64h-25.6v116.48h37.696z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__x)",
    d: "M230.028 305.92V422.4h25.6l5.824-116.48z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__v)",
    d: "M255.628 64h25.6v358.4h-25.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__y)",
    d: "M178.828 201.59l-84.792-40.115H63.628l113.671 62.493h30.069z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__z)",
    d: "M376.023 322.878l-106.765-65.825-10.448 18.06 82.731 47.765z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__A)",
    d: "M106.836 139.305l-12.8 22.17 161.2 88.889 18.741-18.741z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__B)",
    d: "M448.848 337.715l-156.043-90.092-18.741 18.741 161.984 93.521z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__C)",
    d: "M50.828 337.715l25.6 11.085 131.878-83.611h-31.007z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__D)",
    d: "M341.538 169.203l-48.364 27.923v21.322l81.571-49.245z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__E)",
    d: "M81.236 337.715l12.8 22.17L288 249.14l-18.74-18.74z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__F)",
    d: "M436.048 132.194L298.409 211.66l18.74 18.74 131.699-76.036z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__G)",
    d: "M428.8 159.287L373.63 171.9c10.316 15.542 27.974 25.788 48.026 25.788H448c-9.741 0-15.424-23.414-19.2-38.401z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__H)",
    d: "M448 82.488h-26.344c-65.945 0-57.6 25.788-57.6 57.6 0 11.76 3.524 22.696 9.574 31.812h54.095c-8.554-33.959-1.796-89.412 20.275-89.412z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__I)",
    d: "M268.428 76.799l-92.826 12.613c10.316 15.542 27.974 25.788 48.026 25.788h64c-9.741 0-15.424-23.414-19.2-38.401z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__J)",
    d: "M287.628 0h-64c-31.812 0-57.6 25.788-57.6 57.6 0 11.76 3.524 22.696 9.574 31.812h91.752C258.799 55.452 265.557 0 287.628 0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 287.628,
    cy: 57.6,
    r: 57.6,
    fill: "url(#customer-support_svg__K)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__L)",
    d: "M268.428 447.999l-92.826 12.613c10.316 15.542 27.974 25.788 48.026 25.788h64c-9.741 0-15.424-23.414-19.2-38.401z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__M)",
    d: "M287.628 371.2h-64c-31.812 0-57.6 25.788-57.6 57.6 0 11.76 3.524 22.696 9.574 31.812h91.752c-8.555-33.96-1.797-89.412 20.274-89.412z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.628,
    cy: 428.8,
    r: 57.6,
    fill: "url(#customer-support_svg__N)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 448,
    cy: 140.088,
    r: 57.6,
    fill: "url(#customer-support_svg__O)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__P)",
    d: "M428.8 371.199l-55.17 12.613c10.316 15.542 27.974 25.788 48.026 25.788H448c-9.741 0-15.424-23.414-19.2-38.401z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__Q)",
    d: "M448 294.4h-26.344c-31.812 0-57.6 25.788-57.6 57.6 0 11.76 3.524 22.696 9.574 31.812h54.095c-8.554-33.96-1.796-89.412 20.275-89.412z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 448,
    cy: 352,
    r: 57.6,
    fill: "url(#customer-support_svg__R)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__S)",
    d: "M108.8 371.199l-92.826 12.613C26.29 399.354 43.948 409.6 64 409.6h64c-9.741 0-15.424-23.414-19.2-38.401z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__T)",
    d: "M128 294.4H64c-31.812 0-57.6 25.788-57.6 57.6 0 11.76 3.524 22.696 9.574 31.812h91.752C99.171 349.852 105.929 294.4 128 294.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__U)",
    d: "M121.6 166.399l-92.826 12.613C39.09 194.554 56.748 204.8 76.8 204.8h64c-9.741 0-15.424-23.414-19.2-38.401z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__V)",
    d: "M140.8 89.6h-64c-31.812 0-57.6 25.788-57.6 57.6 0 11.76 3.524 22.696 9.574 31.812h91.752c-8.555-33.96-1.797-89.412 20.274-89.412z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.8,
    cy: 147.2,
    r: 57.6,
    fill: "url(#customer-support_svg__W)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 352,
    r: 57.6,
    fill: "url(#customer-support_svg__X)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__Y)",
    d: "M281.227 268.799L217.224 281.6c11.676 15.545 30.266 25.6 51.204 25.6h25.6c-10.149 0-8.481-23.355-12.801-38.401z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#customer-support_svg__Z)",
    d: "M294.028 179.2h-25.6c-35.346 0-64 28.654-64 64 0 14.408 4.761 27.704 12.796 38.4h55.099c-10.727-37.355-3.492-102.4 21.705-102.4z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 294.028,
    cy: 243.2,
    r: 64,
    fill: "url(#customer-support_svg__aa)"
  })));
}
export default __webpack_public_path__ + "static/customer-support.cfe324e2.svg";
export { SvgCustomerSupport as ReactComponent };